import { getAuth, User } from 'firebase/auth';

// Popup sign-in can notify before getAuth().currentUser is readable.
let fallbackUser: User | null = null;

export function setTokenFallbackUser(user: User | null) {
  fallbackUser = user;
}

/**
 * Makes request for refreshed token id if user
 * is logged in.
 * The refreshed token is then set in the request headers
 * @returns
 */
export default async function refreshTokenId(): Promise<string | null> {
  const user = getAuth().currentUser ?? fallbackUser;

  if (!user) return null;
  const token = await user.getIdToken(false);
  return token || null;
}
